export enum WesterosTagsModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
